<template>
  <LcHeader
    v-bind="{ leftButtonIcon }"
    :fly-out-toggle-aria-label="$t('lottery.header.button.flyout')"
    fly-out-toggle-class="paragraph-bold"
    :with-fly-out="showFlyOut"
    @left-button-click="handleClick"
  >
    <template #fly-out-content>
      <LotteryPriceBreakdown scrollable />
    </template>

    <template #fly-out-toggle>
      {{ chargeTotal }}
    </template>

    <template #headline>
      <slot name="headline">
        <LcLotteryLogo v-bind="{ licensedTerritory, lotteryId }" />
      </slot>
    </template>

    <slot />
  </LcHeader>
</template>

<script lang="ts" setup>
import type { LcHeaderProps } from '@lottocom/frontend-components'

type LotteryHeaderProps = Pick<LcHeaderProps, 'leftButtonIcon' | 'withFlyOut'> & {
  onClick?: () => void
}

defineOptions({ inheritAttrs: false })

const { leftButtonIcon = 'arrow-left', onClick, withFlyOut } = defineProps<LotteryHeaderProps>()

const licensedTerritory = useLicensedTerritory({ raw: true })

const { currentPrice, lotteryId } = usePlaySlip()
const { back, chargeTotal, showFlyOut } = usePriceBreakdownHeader(currentPrice, withFlyOut)

const handleClick = () => {
  if (onClick) return onClick()
  back()
}
</script>
